import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { 
    Row, 
    Col
} from "reactstrap";
import swal from 'sweetalert';
import API from '../helpers/API';
import{
    infoSession,
    checkRoleMenu,
    checkRoleUser,
    checkRoleKelas
} from '../config/Utils';
import Header from './Header';
import Menu from './Menu';
import Content from './Content';
import Footer from './Footer';

class DefaultLayout extends Component {
	constructor(props) {
        super(props);
        this.state={
            isReady:false,
        	isLoading:false,
        	xOldPass:'',
        	xNewPass:'',
        	xPassConfirm:'',
        }
        this._handleInputChange=this._handleInputChange.bind(this);
    }

    _handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    _notif(type,title,message){
        swal({
            title: title,
            text: message,
            icon: type,
        });
    }

    _loading(status){
        this.setState({
            isLoading:status
        });
    }

    _clearBox(){
        this.setState({
            xOldPass:'',
        	xNewPass:'',
        	xPassConfirm:'',
        });
    }

    _clickSubmitUbahPassword(){
    	var me = this;
    	if(!this.state.xOldPass){
            this._notif('error', 'Gagal', 'Password lama tidak boleh kosong.');
            return false;
        }

        if(!this.state.xNewPass){
            this._notif('error', 'Gagal', 'Password baru tidak boleh kosong.');
            return false;
        }

        if(!this.state.xPassConfirm){
            this._notif('error', 'Gagal', 'Ketik ulang password baru tidak boleh kosong.');
            return false;
        }

        if(this.state.xNewPass!=this.state.xPassConfirm){
        	this._notif('error', 'Gagal', 'Ketik ulang password baru tidak boleh kosong.');
            return false;
        }

        var params={
        	user:parseInt(infoSession('id')),
            pass_lama:btoa(this.state.xOldPass),
            pass_baru:btoa(this.state.xNewPass)
        };

        this._loading(true);
        API.post('bpd/ubah-password', params).then(respon => {
                if(respon){
                    if(respon.data.result){
                        me._loading(false);
                        document.getElementById('btn-batal-form').click();
                        me._notif('success', 'Sukses', respon.data.message);
                        me._clearBox();
                    }else{
                        me._loading(false);
                        me._notif('error','Gagal', respon.data.message);
                    }
                }else{
                    me._loading(false);
                    me._notif('error','Gagal','Gagal terhubung dengan server. Silahkan cek koneksi internet anda.');
                }
            }).catch(error =>{
                me._loading(false);
                me._notif('error','Gagal',error.message);
                //me._loadDataTable(1,me.state.limit);
        });

    }

    componentDidMount() {
        if(this.state.isLoading){
            this.setState({
                isReady:true,
                isLoading:false
            });
        }
    }

	render() {
        if(!this.state.isReady){
            this.setState({
                isReady:true
            });
            
            //this._loadNotif();
            //document.body.classList.remove('bg_login');
        }
    	return (
    		<div>
        		<Header />
        		<Menu />
        		<Content />
				<Footer />

				<div id="modal-ubah-password" className="modal fade-scale" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header no-padding">
                                <h5 className="modal-title"></h5>
                                <button type="button" className="close" data-dismiss="modal">&times;</button>
                            </div>
                            <div className="modal-body">
                            	<Row>
                            		<Col>
                            			<div className="input-group mb-3">
                                            <div className="col-md-4">
                                                <span className="input-group-text">Old Password <code className="ml-2">*</code></span>
                                            </div>
                                            <div className="col-md-8">
                                            	<input className="form-control input-bg-white" name="xOldPass" value={this.state.xOldPass} onChange={this._handleInputChange.bind(this)} ></input>
                                            </div>
                                         </div>
                                         <div className="input-group mb-3">
                                            <div className="col-md-4">
                                                <span className="input-group-text">New Password <code className="ml-2">*</code></span>
                                            </div>
                                            <div className="col-md-8">
                                            	<input className="form-control input-bg-white" type="password" name="xNewPass" value={this.state.xNewPass} onChange={this._handleInputChange.bind(this)} ></input>
                                            </div>
                                         </div>
                                         <div className="input-group mb-3">
                                            <div className="col-md-4">
                                                <span className="input-group-text">Retype New Password <code className="ml-2">*</code></span>
                                            </div>
                                            <div className="col-md-8">
                                            	<input className="form-control input-bg-white" type="password" name="xPassConfirm" value={this.state.xPassConfirm} onChange={this._handleInputChange.bind(this)} ></input>
                                            </div>
                                         </div>
                            		</Col>
                            	</Row>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-white btn-primary btn-round" onClick={()=>{this._clickSubmitUbahPassword()}}>Simpan</button>
                                <button id="btn-batal-form" data-dismiss="modal" className="btn btn-white btn-danger btn-round" style={{marginLeft:'5px'}}>
                                    Batal
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
      		</div>
    	)
    }
}

export default DefaultLayout;